import apiProtected from '@lib/api/apiClient';
import { asList, getBody, server } from '@lib/api/http';
import { queryKeys } from '@lib/api/queryKeys';
import { useSession } from '@lib/auth/session';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useNotificationsQuery = (limit?: number, enabled = true) => {
  const loggedIn = useSession();
  return useQuery({
    queryKey: queryKeys.notifications(limit),
    queryFn: async () =>
      asList(
        await getBody<{ data?: unknown[] }>(
          `${server}v1/notifications/get-all-notifications`,
          { limit }
        )
      ),
    enabled: loggedIn && enabled,
  });
};

export const useDeleteNotificationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (notificationId: string | number) =>
      apiProtected.delete(`${server}v1/notifications`, {
        params: { notificationId },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      queryClient.invalidateQueries({ queryKey: queryKeys.dashboard });
    },
  });
};

export const useClearNotificationsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiProtected.delete(`${server}v1/notifications/delete-all-notifications`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      queryClient.invalidateQueries({ queryKey: queryKeys.dashboard });
    },
  });
};
